import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ReSelectComponent } from './re-select.component';

@NgModule({
  imports: [CommonModule, NgSelectModule, FormsModule],
  declarations: [ReSelectComponent],
  exports: [ReSelectComponent],
  providers: [DatePipe],
})
export class ReSelectModule {}
